import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'
import { FaCamera } from 'react-icons/fa'

import Loader from 'components/Loader'


const Input = (props, ref) => {
  const timeoutms = props.timeoutms
  const timeout = React.useRef(null)

  React.useEffect(() => {
    if (ref && props.focusAuto) {
      setTimeout(() => ref.current.focus(), 200)
    }
  }, []) // eslint-disable-line

  const onChange = e => {
    if (timeoutms) {
      if (timeout.current) {
        clearTimeout(timeout.current)
      }

      timeout.current = setTimeout(
        () => props.onChange(e),
        timeoutms,
      )
    } else {
      props.onChange(e)
    }
  }

  return (
    <div className='relative mb-5'>
      <input
        {...props.inputProps}
        onChange={props.onChange && onChange}
        ref={ref}
        className={classNames([
          'placeholder-gray-400 text-gray-700 bg-white',
          'focus:outline-none focus:ring ring-primary-600',
          'border-0 p-4 rounded text-sm shadow w-full',
          {
            'pr-10': props.loading,
          },
          props.className,
        ])}
      />
      {
        props.loading &&
        <div className='absolute right-3 top-1/2 transform -translate-y-1/2'>
          <Loader active/>
        </div>
      }
    </div>
  )
}

Input.propTypes = {
  className: propTypes.string,
  focusAuto: propTypes.bool,
  loading: propTypes.bool,
  timeoutms: propTypes.number,
  inputProps: propTypes.object,
}

Input.defaultProps = {
  loading: false,
}

export default React.forwardRef(Input)


export function InputFile(props) {
  const [inputState, setInputState] = React.useState(null)
  const [inputChanged, setInputChanged] = React.useState(null)

  const inputRef = React.useCallback(
    setInputState,
    [setInputState],
  )

  React.useEffect(() => {
    if (inputState) {
      inputState.addEventListener('change', (e) => {
        setInputChanged(e.target.value.split('\\').pop())
      }, false)
    }

    return () => {
      if (inputState) {
        inputState.removeEventListener('change', () => { }, false)
      }
    }
  }, [inputState])

  return (
    <div
      className={classNames([
        'flex items-center',
        props.containerClassName,
      ])}
    >
      <label
        className={classNames([
          'btn cursor-pointer default inverted flex-grow-0 flex-shrink-0 relative',
          props.className,
        ])}
      >
        <Loader
          active={props.loading}
          className='
            text-white
            absolute left-1/2 top-1/2
            transform -translate-x-1/2 -translate-y-1/2
          '
        />
        <span className={
          classNames(
            'transition-all',
            {
            'opacity-0': props.loading,
            },
          )
        }>{props.label || 'Upload File'}</span>
        <input
          {...props.inputProps}
          onChange={props.onChange}
          ref={inputRef}
          type='file'
          className='opacity-0 absolute left-0 top-0 w-1 h-1'
        />
      </label>
      {
        (inputChanged || props.filename) &&
          <div className='text-disabled-600 ml-5 text-sm'>{inputChanged || props.filename}</div>
      }
    </div>
  )
}

export function InputFileIcon(props) {
  return (
    <label
      className={classNames([
        'bg-gray-300 text-lg rounded-full',
        props.className,
      ])}
    >
      {
        (props.loading === true) ? (
          <Loader active className='text-white'/>
        ) : (
          props.icon || <FaCamera/>
        )
      }
      <input
        {...props.inputProps}
        onChange={props.onChange}
        type='file'
        className='hidden'
      />
    </label>
  )
}

InputFile.propTypes = {
  className: propTypes.string,
  containerClassName: propTypes.string,
  label: propTypes.string,
  inputProps: propTypes.object,
  onChange: propTypes.func,
  loading: propTypes.bool,
}

InputFile.defaultProps = {
  loading: false,
}

InputFileIcon.propTypes = {
  className: propTypes.string,
  containerClassName: propTypes.string,
  icon: propTypes.string,
  inputProps: propTypes.object,
  onChange: propTypes.func,
  loading: propTypes.bool,
}

InputFileIcon.defaultProps = {
  loading: false,
}


export function InputCheckbox(props) {
  return (
    <div className={classNames(
      'relative',
      props.containerClassName,
    )}>
      <label className={classNames(
        'inline-flex items-center',
        {'line-through text-disabled-300': props.disabled}
      )}>
        <Loader active={!!props.loading} />
        {
          ! props.loading &&
          <input
            disabled={props.disabled}
            {...props.inputProps}
            type='checkbox'
            className={classNames([
              props.className,
              'placeholder-gray-400 text-gray-700 bg-white',
              'focus:outline-none focus:ring ring-primary-600',
              'border-0 rounded text-sm shadow',
              'form-checkbox',
            ])}
            onChange={props.onChange}
          />
        }
        <span className='ml-2'>{props.placeholder}</span>
      </label>
    </div>
  )
}

InputCheckbox.propTypes = {
  className: propTypes.string,
  containerClassName: propTypes.string,
  loading: propTypes.bool,
  disabled: propTypes.bool,
  placeholder: propTypes.string,
  onChange: propTypes.func.isRequired,
  inputProps: propTypes.object,
}

InputCheckbox.defaultProps = {
  loading: false,
}
